import { DEFAULT_DPI_VALUES } from '../../orders/layouts';
import { SnapshotModel } from '..';
import { Collections } from '../../constants';
import { ModularSize } from '../../types';

export class ModularSizeModel extends SnapshotModel<
  ModularSize,
  typeof Collections.modularSizes
> {
  get type() {
    return Collections.modularSizes;
  }

  public heightInPixels({ dpi = DEFAULT_DPI_VALUES.PUPPETEER } = {}) {
    const heightInInches = this.modelData.height;
    const heightInPixels = Math.ceil(heightInInches * dpi);
    return heightInPixels;
  }

  public widthInPixels({ dpi = DEFAULT_DPI_VALUES.PUPPETEER } = {}) {
    const widthInInches = this.modelData.width;
    const widthInPixels = Math.ceil(widthInInches * dpi);
    return widthInPixels;
  }
}
